import { CoreCurrency } from "@mm-products/java-multima-framework";
import { TaxAbraDocumentTypeDto, TaxDocumentDto } from "../../../backend/taxguru";
import { FieldPath } from "react-hook-form";
import { Dayjs } from "dayjs";

export type DocumentDetailFormTypes = {
    ownerNote?: TaxDocumentDto["ownerNote"];
    processorNote?: TaxDocumentDto["processorNote"];
    kind?: TaxDocumentDto["kind"] | "";
    type?: TaxDocumentDto["type"] | "";
    regNumber?: TaxDocumentDto["regNumber"];
    owner?: TaxDocumentDto["owner"];
    customerCompanyIdNumber?: TaxDocumentDto["customerCompanyIdNumber"];
    supplierCompanyIdNumber?: TaxDocumentDto["supplierCompanyIdNumber"];
    supplierTaxIdNumber?: TaxDocumentDto["supplierTaxIdNumber"];
    currency?: CoreCurrency | null; // support field
    description?: TaxDocumentDto["description"];
    supplier?: TaxDocumentDto["supplier"];
    preAccounting?: TaxDocumentDto["preAccounting"];
    supplierPerson?: TaxDocumentDto["supplierPerson"];
    issueDate?: Dayjs | null;
    taxableSupplyDate?: Dayjs | null;
    vatApplicationDate?: Dayjs | null;
    dueDate?: Dayjs | null;
    amountTotal?: TaxDocumentDto["amountTotal"] | "";
    paymentMeans?: TaxDocumentDto["paymentMeans"] | "";
    payableAmount?: TaxDocumentDto["payableAmount"] | "";
    baseTotal?: TaxDocumentDto["baseTotal"] | "";
    vatTotal?: TaxDocumentDto["vatTotal"] | "";
    baseVatBasic?: TaxDocumentDto["baseVatBasic"] | "";
    baseVatReduced?: TaxDocumentDto["baseVatReduced"] | "";
    baseVatReduced2?: TaxDocumentDto["baseVatReduced2"] | "";
    baseVat0?: TaxDocumentDto["baseVat0"] | "";
    baseVatNone?: TaxDocumentDto["baseVatNone"] | "";
    baseVatUnknown?: TaxDocumentDto["baseVatUnknown"] | "";
    vatBasic?: TaxDocumentDto["vatBasic"] | "";
    vatReduced?: TaxDocumentDto["vatReduced"] | "";
    vatReduced2?: TaxDocumentDto["vatReduced2"] | "";
    vatUnknown?: TaxDocumentDto["vatUnknown"] | "";
    amountVatBasic?: TaxDocumentDto["amountVatBasic"] | "";
    amountVatReduced?: TaxDocumentDto["amountVatReduced"] | "";
    amountVatReduced2?: TaxDocumentDto["amountVatReduced2"] | "";
    amountVatUnknown?: TaxDocumentDto["amountVatUnknown"] | "";
    classification?: TaxDocumentDto["classification"] | "";
    abraDocumentType?: TaxAbraDocumentTypeDto | null;

    // TODO only for learning
    vat0?: never;
    amountVat0?: never;
    vatRate0?: never;
    vatRateNone?: never;
    vatRateReduced2?: never;
    vatRateReduced?: never;
    vatRateBasic?: never;
    vatRateUnknown?: never;

    centre?: TaxDocumentDto["centre"] | null;
    contract?: TaxDocumentDto["contract"] | null;
    activity?: TaxDocumentDto["activity"] | null;
    recogniserSupplierName?: TaxDocumentDto["recogniserSupplierName"] | "";
    recogniserSupplierAddress?: TaxDocumentDto["recogniserSupplierAddress"] | "";
    reverseCharge?: TaxDocumentDto["reverseCharge"] | "";
    vatApplicable?: TaxDocumentDto["vatApplicable"] | "";
    variableSymbol?: TaxDocumentDto["variableSymbol"] | "";
    accountNumber?: TaxDocumentDto["accountNumber"] | "";
    bankCode?: TaxDocumentDto["bankCode"] | "";
    iban?: TaxDocumentDto["iban"] | "";
    bic?: TaxDocumentDto["bic"] | "";
};

export const documentDateObjectFields: Set<FieldPath<DocumentDetailFormTypes>> = new Set([
    "issueDate",
    "taxableSupplyDate",
    "vatApplicationDate",
    "dueDate",
]);
export const documentObjectFields: Set<FieldPath<DocumentDetailFormTypes>> = new Set([
    "owner",
    "supplier",
    "supplierPerson",
    "currency",
    "preAccounting",
]);
export const documentNoLearningFields: Set<FieldPath<DocumentDetailFormTypes>> = new Set([
    "processorNote",
    "ownerNote",
    "owner",
    "supplier",
    "paymentMeans",
    "supplierPerson",
    "kind",
    "type",
    "currency",
    "centre",
    "reverseCharge",
    "vatApplicable",
]);
export const documentNumberFields: Set<FieldPath<DocumentDetailFormTypes>> = new Set([
    "amountTotal",
    "payableAmount",
    "baseTotal",
    "vatTotal",
    "baseVatBasic",
    "baseVatReduced",
    "baseVatReduced2",
    "baseVat0",
    "baseVatNone",
    "baseVatUnknown",
    "vatBasic",
    "vatReduced",
    "vatReduced2",
    "amountVatBasic",
    "amountVatReduced",
    "amountVatReduced2",
    "amountVatUnknown",
]);

export const documentTaxFields: Set<FieldPath<DocumentDetailFormTypes>> = new Set([
    "baseVatBasic",
    "vatBasic",
    "vatUnknown",
    "amountVatBasic",
    "baseVatReduced",
    "vatReduced",
    "amountVatReduced",
    "amountVatUnknown",
    "baseVatReduced2",
    "vatReduced2",
    "amountVatReduced2",
    "baseVat0",
    "baseVatNone",
    "baseVatUnknown",
    // TODO only for learning
    "vat0",
    "amountVat0",
    "vatRate0",
    "vatRateNone",
    "vatRateReduced2",
    "vatRateReduced",
    "vatRateBasic",
    "vatRateUnknown",
]);

export const fieldOnlyForRecogniser: Set<FieldPath<DocumentDetailFormTypes>> = new Set([
    "vat0",
    "amountVat0",
    "vatRate0",
    "vatRateReduced2",
    "vatRateReduced",
    "vatRateBasic",
    "vatRateUnknown",
]);
